export const devCollectionId = {
  TAIPEI_PARKING: '4d37285b-5232-49ec-a2a3-1f45d3e87def',
  TIMES: '06b9df1e-971d-40a9-8660-af014619ca03',
  HOTAI_POINT_PARKINGLOTS: '3504a083-e65e-4510-a04c-c3a43bc6bb29',
  RICHART_LIFE_FREE_PARKING_PARKINGLOT: '4aa97b96-8464-400c-ae41-388dbcaead02',
};

export const prodCollectionId = {
  TAIPEI_PARKING: '3d80025c-0a7b-4bcb-863c-8365bc6d7069',
  TIMES: '0396f81e-b8bb-445d-8c71-98b5788b70c2',
  HOTAI_POINT_PARKINGLOTS: '744ace5b-a1c6-482c-ad0a-ad11367cd91f',
  RICHART_LIFE_FREE_PARKING_PARKINGLOT: 'fb09fcd5-bb46-42b5-9fcc-ef5c3f4f72a4',
};
